import React from "react";
import { connect } from "react-redux";

import Divider from "antd/es/divider";
import cn from "classnames";
import { useIntl } from "react-intl";

import ReportType from "@app/enum/ReportType";
import OwnerManagerMenu from "@app/scene/reports/components/Header/components/OwnerManagerMenu";
import getReportsHeaderDisplayName from "@app/scene/reports/utils/getReportsHeaderDisplayName";
import { RootState } from "@app/store/rootReducer";
import formatDateRange from "@app/util/stackRank/formatDateRange";

import { getDateRange } from "../../store/selectors";
import DateRange from "../../types/DateRange";

import styles from "./StandardHeader.module.scss";
import TimeSelector from "./TimeSelector";

interface Props {
  className?: string;
  dateRange: DateRange;
  extra?: React.ReactNode;
  hideOwnerManagerMenu?: boolean;
  isTimeSelectorDateDisabled?: (date: Date) => boolean;
  reportType: ReportType;
  timeSelectorOnlyCustom?: boolean;
}

const Header: React.FC<Props> = ({
  className,
  dateRange,
  extra,
  hideOwnerManagerMenu,
  isTimeSelectorDateDisabled,
  reportType,
  timeSelectorOnlyCustom,
}) => {
  const intl = useIntl();

  return (
    <>
      <div className={cn(styles.container, className)}>
        <div className={styles.showTitle}>
          <div className={styles.title}>{getReportsHeaderDisplayName(intl, reportType)}</div>
          {!hideOwnerManagerMenu && (
            <div className={styles.button}>
              <OwnerManagerMenu />
            </div>
          )}
        </div>
        <div>
          <div className={styles.dateComponent}>
            {reportType === ReportType.OVERVIEW ? (
              <>
                <div className={styles.dateRange}>{formatDateRange(dateRange)}</div>
                <TimeSelector
                  isDateDisabled={isTimeSelectorDateDisabled}
                  onlyCustom={timeSelectorOnlyCustom}
                  reportType={reportType}
                />
              </>
            ) : (
              extra
            )}
          </div>
        </div>
      </div>
      <Divider className={styles.divider} orientation="left" />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  dateRange: getDateRange(state),
});

export default connect(mapStateToProps)(Header);
